import { UseQueryOptions } from 'react-query';

import { DefaultDateType } from '../../types';

import { useList } from '../../../../../../../api/react-query';

type Params = {
  employeeId?: string | number;
  days?: number | number;
  startDate?: DefaultDateType | null;
  limit?: number;
};

type Props = {
  params: Params;
  config?:
    | Omit<UseQueryOptions<any, unknown, any, object[]>, 'queryKey' | 'queryFn'>
    | undefined;
};

export function useListEmployeeRoster({
  params: { employeeId, days, startDate, limit = 10 },
  config = {},
}: Props) {
  const { data, isRefetching, isFetching, isLoading } = useList(
    'shift-management/employees/shift-rosters',
    {
      employeeId,
      days,
      startDate,
      limit,
    },
    config,
  );

  return {
    data: data?.data?.data,
    isLoading: isLoading || isRefetching || isFetching,
  };
}
